<template>
    <a :href="href" class="col-4 shortcut-item" :style="{color: appColor.secondary}">
        <span class="shortcut-media avatar rounded-circle bg-gradient-red" :class="`bg-gradient-${color}`">
            <i class="icon-size" :class="icon"></i>
        </span>
        <small :class="dev ? 'indev' : ''">{{name}}</small>
    </a>
</template>

<script>
export default {
    name: 'NavbarMenuItem',
    props: {
        href: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        color: {
            type: String,
            required: true
        },
        dev: {
            type: Boolean
        }
    },
    computed: {
        appColor() {
            return this.$store.getters.COLOR;
        }
    }

}
</script>

<style scoped>
    .icon-size {
        font-size: 1.2rem
    }
    .indev {
        text-decoration: line-through;
    }
</style>
